import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	input,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { EMPTY, Subscription, catchError } from 'rxjs';

import { ReportModalComponent } from './report-modal/report-modal.component';
import { ReportModalApiService } from '../../data-access/services/report-modal-api.service';
import { ReviewCardService } from '../../services/review-card.service';
import { ShareModalComponent } from './share-modal/share-modal.component';
import { ShareModalService } from '../../services/share-modal.service';
import { ReviewReaction } from '../../models/university-reviews.models';
import { UniversityReview } from '@uc/web/shared/data-models';
import { NotLoggedinModalComponent } from '@web/shared/ui';
import { ModalService, SearchBarService } from '@uc/shared/ui';
import { CustomCookieService } from '@uc/shared/authentication';
import { UniversityReviewsApiService } from '../../data-access/services/university-reviews-api.service';
import { ToastrService } from 'ngx-toastr';
import { AsyncPipe, NgClass } from '@angular/common';
import { ReviewHeaderComponent } from './review-header/review-header.component';
import { EntitiesPipe, HighlightSearchPipe } from '@uc/utilities';
import { ReviewReactionComponent } from './review-reaction/review-reaction.component';
import { ReviewThreeDotsComponent } from './review-three-dots/review-three-dots.component';

@Component({
	selector: 'uc-review-card',
	templateUrl: './review-card.component.html',
	imports: [
		NgClass,
		AsyncPipe,
		EntitiesPipe,
		HighlightSearchPipe,
		ReviewHeaderComponent,
		ReviewReactionComponent,
		ReviewThreeDotsComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewCardComponent implements OnInit, OnDestroy {
	review = input.required<UniversityReview>();
	topReview = input<boolean>();
	universityName = input<string | undefined>();
	universityUrl = input<string | undefined | null>();
	inputValue$ = this._searchSrv.inputValue$;
	userId!: number | null;
	avatar!: string;

	inputValueSub!: Subscription;
	reviewReactionSub!: Subscription;

	constructor(
		private _cd: ChangeDetectorRef,
		private _customCookieSrv: CustomCookieService,
		private _searchSrv: SearchBarService,
		private _modalSrv: ModalService,
		private _reviewSrv: ReviewCardService,
		private _universityReviewsApiSrv: UniversityReviewsApiService,
		private _shareSrv: ShareModalService,
		private _reportApiSrv: ReportModalApiService,
		private _toastr: ToastrService,
	) {
		const userId = this._customCookieSrv.get('user_id');
		this.userId = userId ? +userId : null;
	}

	ngOnInit(): void {
		if (this.review && !this.review().avatar) {
			this.avatar = this._reviewSrv.getRandomAvatar();
		}
	}

	onReviewReaction(args: ReviewReaction) {
		if (!this.userId) {
			this._showNotLoggedInModal();
			return;
		}

		this.reviewReactionSub = this._universityReviewsApiSrv
			.voteOnReview(args.reviewId, args.reaction)
			.pipe(
				catchError((error) => {
					console.error(error);
					if (error.status === 401) {
						this._showNotLoggedInModal();
					} else {
						this._toastr.show(
							'error',
							'An unknown error occurred. Please try again.',
						);
					}
					return EMPTY;
				}),
			)
			.subscribe(() => {
				this._reviewSrv.editReactionStatus(this.review(), args.reaction);
				this._cd.markForCheck();
			});
	}

	showModalPanel(params: string) {
		if (!params) return;
		this._modalSrv.setContent(
			params === 'share' ? ShareModalComponent : ReportModalComponent,
		);
		this._modalSrv.show();

		if (params === 'share') {
			const shareData = {
				review: this.review(),
				universityName: this.universityName(),
				universityUrl: this.universityUrl(),
			};
			this._shareSrv.setShareData(shareData);
			return;
		}
		this._reportApiSrv.setReviewId(this.review().id);
	}

	ngOnDestroy(): void {
		this.inputValueSub?.unsubscribe();
		if (this.reviewReactionSub) this.reviewReactionSub.unsubscribe();
	}

	private _showNotLoggedInModal() {
		this._modalSrv.setContent(NotLoggedinModalComponent);
		this._modalSrv.show();
	}
}
